// A place to keep your menu scripting (ex. toggling a mobile menu)
(function($){

		$(window).resize(handleWindowResize);
		handleWindowResize();

		function handleWindowResize() {
			if ($(window).width() <= 1100) {
				$(".primary-menu").addClass("mobile-primary");
				$("body").addClass("mobile");
			} else {
				$(".primary-menu").removeClass("mobile-primary");
				$("body").removeClass("mobile");
			}
		}

	// Handle menu interactions
	$(".main-menu-toggle").click(function() {
		mainNav();
	});

	function mainNav() {
		$(".main-menu-toggle").toggleClass("cross");
		$("body").toggleClass("modal-open");
		$(".mobile-primary").toggleClass("open");
	}
})(jQuery);
